export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_DELETED = 'ACCOUNT_DELETED';
export const GET_EVENT = 'GET_EVENT';
export const EVENT_ERROR = 'EVENT_ERROR';
export const CLEAR_EVENT = 'CLEAR_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_USER = 'GET_USER';
export const GET_USERS = 'GET_USERS';
export const USER_ERROR = 'USER_ERROR';
export const UPDATE_USER = 'UPDATE_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const USER_DELETED = 'USER_DELETED';
export const GET_COTATION = 'GET_COTATION';
export const GET_COTATIONS = 'GET_COTATIONS';
export const GET_MANUFACTURER = 'GET_MANUFACTURER';
export const GET_MODEL = 'GET_MODEL';
export const COTATION_ERROR = 'COTATION_ERROR';
export const UPDATE_COTATION = 'UPDATE_COTATION';
export const CLEAR_COTATION = 'CLEAR_COTATION';
export const COTATION_DELETED = 'COTATION_DELETED';
